import service from '@/services/account';
import { changeLocale } from '@/i18n';

export const CACHE_KEY = 'opwCache';
export const STORE_KEY = 'opwStore';

const commitData = async (store, data) => {
  const {
    firstAdjustedWidgets: hasCustomizedWidgets,
    firstWidgetsInstallation: hasInstalledWidgets,
    importedReviews: hasImportedReviews,
    dashboardLanguage,
    logoUrl,
    sendReviewRequests,
    ...account
  } = data;

  store.commit(
    'getAccountInfoSuccess',
    {
      ...account,
      logoUrl,
      hasInstalledWidgets,
      hasCustomizedWidgets,
      hasImportedReviews,
    },
    {
      root: true,
    }
  );
  dashboardLanguage && changeLocale(dashboardLanguage);
  store.commit('settings/setSendReviewRequests', sendReviewRequests, {
    root: true,
  });
  store.commit('settings/setLogoUrl', logoUrl, { root: true });
};

const FirstDataFetcher = async store => {
  try {
    const storeId = store.getters['auth/getShopId'];
    sessionStorage.setItem(STORE_KEY, storeId);

    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
    if (cache[storeId]) {
      commitData(store, cache[storeId]);
    }
    store.commit('updateLoadingCount', 1);

    const { data } = await service.getEssentialData();
    await store.dispatch('loadBaseConfig');
    store.commit('updateLoadingCount', -1);

    cache[storeId] = data;
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));

    commitData(store, data);
  } catch (e) {
    console.error(e);
  }
};

export default FirstDataFetcher;
